export default {"src":"/_next/static/media/logo.0ab387c9.svg","height":32,"width":80,"blurWidth":0,"blurHeight":0};